"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _IconButton = _interopRequireDefault(require("../IconButton/IconButton"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var BannerTitle = (0, _styledComponents["default"])(_Text["default"]).withConfig({
  displayName: "PromotionBanner__BannerTitle",
  componentId: "sc-fwykod-0"
})(["text-transform:uppercase;"]);

var PromotionBanner = function PromotionBanner(_ref) {
  var title = _ref.title,
      onDismiss = _ref.onDismiss,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    width: 1 / 1,
    bg: "secondary.1",
    p: 3,
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    flexDirection: "column",
    mr: 3
  }, title && /*#__PURE__*/_react["default"].createElement(BannerTitle, {
    fontWeight: "500",
    color: "dark.2",
    mb: 1
  }, title), children), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    m: 0,
    icon: "close",
    width: "auto",
    onClick: onDismiss
  }));
};

var _default = PromotionBanner;
exports["default"] = _default;